import { Monitor, Moon, Sun } from 'lucide-react';
import { t } from '@/i18n';
import { cn } from '@/lib/cn';
import { useTheme, type ThemePref } from '@/lib/theme';

const options: Array<{ value: ThemePref; icon: typeof Sun; label: () => string }> = [
  { value: 'light', icon: Sun, label: () => t('theme.light') },
  { value: 'dark', icon: Moon, label: () => t('theme.dark') },
  { value: 'system', icon: Monitor, label: () => t('theme.system') },
];

export function ThemeSwitcher({ className }: { className?: string }) {
  const { pref, setPref } = useTheme();
  return (
    <div role="radiogroup" aria-label={t('theme.label')} className={cn('inline-flex rounded-control bg-surface-2 p-0.5', className)}>
      {options.map(({ value, icon: Icon, label }) => (
        <button
          key={value}
          role="radio"
          aria-checked={pref === value}
          aria-label={label()}
          title={label()}
          onClick={() => setPref(value)}
          className={cn(
            'inline-flex h-7 w-8 items-center justify-center rounded-[8px] transition-colors',
            pref === value ? 'bg-surface text-fg shadow-card' : 'text-fg-subtle hover:text-fg',
          )}
        >
          <Icon className="size-4" strokeWidth={1.75} />
        </button>
      ))}
    </div>
  );
}
